module.exports = __webpack_public_path__ + "img/hm-icon.203e81dd.svg";